import { gql } from 'graphql-request';

export const CREATE_EVENT = gql`
  mutation insertEventOne($id: uuid, $actionId: uuid, $recurrence: jsonb, $start: timestamptz, $end: timestamptz) {
    insertEventOne(object: { id: $id, actionId: $actionId, recurrence: $recurrence, start: $start, end: $end }) {
      id
      actionId
      action {
        id
        seriesId
        categoryId
        blockId
        title
        duration
        dateOfStarring
        categoryOrder
        blockOrder
        notes
        progressStatus
        isLocked
        category {
          name
          icon
          id
          color
        }
        scheduledDate
        scheduledTime
        timezone
        gmtOffset
        weeklyPlanId
        weekly_plan {
          dateFrom
          dateTo
        }
        project {
          name
        }
        promises {
          kind
          leverageRequestStatus
          person {
            name
          }
          personId
          id
        }
      }
    }
  }
`;

export const CREATE_EVENTS = gql`
  mutation insertEvent($objects: [EventInsertInput!]!) {
    insertEvent(objects: $objects) {
      returning {
        id
        actionId
        action {
          id
          seriesId
          createdAt
          categoryId
          blockId
          title
          duration
          dateOfStarring
          categoryOrder
          blockOrder
          notes
          progressStatus
          isLocked
          category {
            name
            icon
            id
            color
          }
          scheduledDate
          scheduledTime
          timezone
          gmtOffset
          weeklyPlanId
          weekly_plan {
            dateFrom
            dateTo
          }
          project {
            name
          }
          promises {
            kind
            leverageRequestStatus
            person {
              name
            }
            personId
            id
          }
        }
      }
    }
  }
`;

export const DELETE_EVENT_BY_ID = gql`
  mutation deleteEventByPk($id: uuid!) {
    deleteEventByPk(id: $id) {
      id
    }
  }
`;

export const EVENT_BY_PK = gql`
  query eventByPk($id: uuid!) {
    eventByPk(id: $id) {
      id
      recurrence
    }
  }
`;

export const UPDATE_EVENT = gql`
  mutation updateEventOne($id: uuid!, $recurrence: jsonb, $start: timestamptz, $end: timestamptz) {
    updateEventByPk(pkColumns: { id: $id }, _set: { recurrence: $recurrence, start: $start, end: $end }) {
      id
      actionId
      action {
        id
        seriesId
        categoryId
        blockId
        title
        duration
        dateOfStarring
        categoryOrder
        blockOrder
        notes
        progressStatus
        isLocked
        category {
          name
          icon
          id
          color
        }
        scheduledDate
        scheduledTime
        timezone
        gmtOffset
        weeklyPlanId
        weekly_plan {
          dateFrom
          dateTo
        }
        project {
          name
        }
        promises {
          kind
          leverageRequestStatus
          person {
            name
          }
          personId
          id
        }
      }
      recurrence
      end
      start
    }
  }
`;
